// extracted by mini-css-extract-plugin
export default {"wrapper":"AddClientForm_wrapper__KuYfg","controlWrapper":"AddClientForm_controlWrapper__hT3lr","phoneInputWrapper":"AddClientForm_phoneInputWrapper__EK9Mc"};